import { z } from "astro/zod";

export const countrySchema = z.string().min(1);

export type CountryType = z.infer<typeof countrySchema>;
